import commonEN from './en/common.json';
import commonHU from './hu/common.json';

import integrationsEN from './en/integrations.json';
import integrationsHU from './hu/integrations.json';

import messageWhaleEN from './en/messageWhale.json';
import messageWhaleHU from './hu/messageWhale.json';

import notificationsEN from './en/notifications.json';
import notificationsHU from './hu/notifications.json';

import workflowEN from './en/workflow.json';
import workflowHU from './hu/workflow.json';
import errorsEN from './en/errors.json';
import errorsHU from './hu/errors.json';

import popupEditorEN from './en/popup-editor.json';
import popupEditorHU from './hu/popup-editor.json';

import resourcesEN from './en/resources.json';
import resourcesHU from './hu/resources.json';

export const resources = {
  'en-US': {
    common: commonEN,
    integrations: integrationsEN,
    messageWhale: messageWhaleEN,
    notifications: notificationsEN,
    workflow: workflowEN,
    errors: errorsEN,
    popupEditor: popupEditorEN,
    resources: resourcesEN,
  },
  'hu-HU': {
    common: commonHU,
    integrations: integrationsHU,
    messageWhale: messageWhaleHU,
    notifications: notificationsHU,
    workflow: workflowHU,
    errors: errorsHU,
    popupEditor: popupEditorHU,
    resources: resourcesHU,
  },
};
